import service from "@/utils/service.js"

export const projectCreate = data => {
  return service({
    url: "/api/plantIQ/project/create",
    method: "post",
    data
  })
}

export const projectDetails = data => {
  return service({
    url: "/api/plantIQ/project/details",
    method: "post",
    data
  })
}

export const projectPreAnalysis = data => {
  return service({
    url: "/api/plantIQ/project/preAnalysis",
    method: "post",
    data
  })
}

export const projectPreReport = data => {
  return service({
    url: "/api/plantIQ/project/preReport",
    method: "post",
    // responseType: "blob",
    data
  })
}

export const preAnalysisCoolingLoad = data => {
  return service({
    url: "/api/plantIQ/project/preAnalysis/coolingLoad",
    method: "post",
    data
  })
}

export const preAnalysisPower = data => {
  return service({
    url: "/api/plantIQ/project/preAnalysis/power",
    method: "post",
    data
  })
}

export const saveProjectFiles = data => {
  return service({
    url: "/api/plantIQ/project/files",
    method: "post",
    data
  })
}

export const deleteProjectFiles = data => {
  return service({
    url: "/api/plantIQ/project/files/delete",
    method: "post",
    data
  })
}

export const calculateMonthlyCapacity = data => {
  return service({
    url: "/api/plantIQ/project/calculate/monthlyCapacity",
    method: "post",
    data
  })
}

export const calculateChillerNumber = data => {
  return service({
    url: "/api/plantIQ/project/calculate/chillerNumber",
    method: "post",
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/projectPre.js